// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-tooltip-inner .tooltip-inner {\n  max-width: 100%;\n}\n.stock-movement-popup-table .table-container {\n  max-height: 60vh;\n  overflow-y: scroll;\n}\n[dir] .stock-movement-popup-table .table-tooltip td {\n  background-color: white;\n}", ""]);
// Exports
module.exports = exports;
